import { render, staticRenderFns } from "./TimeFromNow.vue?vue&type=template&id=7c75b132"
import script from "./TimeFromNow.vue?vue&type=script&lang=ts"
export * from "./TimeFromNow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports